module.exports = __webpack_public_path__ + "assets/bootstrap.68823e17.svg";